import React from 'react';
import { Link } from 'react-router-dom';
import { useCosmeticCatalog } from '../../context/CatalogContext';
import { getCosmeticComponent } from '../cosmetics';
import {
  RELEASE_COSMETIC_COUNT,
  RELEASE_COSMETIC_SHOWCASE,
  RELEASE_COSMETIC_PREVIEWS,
} from './releaseCatalog';

const BROWSE_HREF = '/catalog?type=cosmetic';

// Renders the bottom strip on the release hero. We show a curated showcase of
// cosmetic SVGs (variety of slots, always renders), then a "Browse all" tile
// that points at the cosmetics tab of the catalog.
export default function CosmeticReleaseStrip() {
  const catalog = useCosmeticCatalog();
  const catalogById = React.useMemo(() => {
    const map = {};
    (catalog || []).forEach((c) => { map[c.id] = c; });
    return map;
  }, [catalog]);

  return (
    <div className="cosmetic-strip-wrap">
      <div className="cosmetic-strip-head">
        <h3>{RELEASE_COSMETIC_COUNT} fresh cosmetics, dressed to match.</h3>
        <Link to={BROWSE_HREF} className="cosmetic-strip-link">
          Browse all →
        </Link>
      </div>
      <div className="cosmetic-strip">
        {RELEASE_COSMETIC_SHOWCASE.map((id) => {
          const previewUrl = RELEASE_COSMETIC_PREVIEWS[id];
          const Svg = getCosmeticComponent(id);
          const meta = catalogById[id];
          const label = meta?.name || id.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
          return (
            <Link
              key={id}
              to={`/catalog/cosmetic/${id}`}
              className="cosmetic-strip-tile"
              title={label}
              aria-label={label}
            >
              {previewUrl
                ? <img src={previewUrl} alt={label} loading="lazy" />
                : Svg
                  ? <Svg size={72} />
                  : <span style={{ fontSize: 11, padding: 6, textAlign: 'center' }}>{label}</span>}
            </Link>
          );
        })}
        <Link to={BROWSE_HREF} className="cosmetic-strip-tile cosmetic-strip-more">
          <span className="more-count">+{RELEASE_COSMETIC_COUNT - RELEASE_COSMETIC_SHOWCASE.length}</span>
          <span>more</span>
        </Link>
      </div>
    </div>
  );
}
